var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinkheart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1211 0.18457C15.963 0.18457 14.0477 1.08654 12.75 2.63682C11.4523 1.08654 9.53701 0.18457 7.37891 0.18457C5.49926 0.186978 3.69725 0.978654 2.36814 2.38595C1.03903 3.79324 0.291337 5.70125 0.289062 7.69146C0.289063 15.9195 11.6554 22.4937 12.1388 22.7701C12.3266 22.8772 12.5366 22.9333 12.75 22.9333C12.9634 22.9333 13.1734 22.8772 13.3612 22.7701C13.8446 22.4937 25.2109 15.9195 25.2109 7.69146C25.2087 5.70125 24.461 3.79324 23.1319 2.38595C21.8027 0.978654 20.0007 0.186978 18.1211 0.18457ZM17.5313 16.3767C16.0352 17.7209 14.4359 18.9308 12.75 19.9937C11.0641 18.9308 9.46475 17.7209 7.96865 16.3767C5.64082 14.2623 2.86719 11.0377 2.86719 7.69146C2.86719 6.42449 3.34253 5.20942 4.18864 4.31353C5.03475 3.41765 6.18232 2.91435 7.37891 2.91435C9.29102 2.91435 10.8916 3.98351 11.5565 5.70555C11.6533 5.95658 11.8185 6.17141 12.0311 6.32263C12.2436 6.47384 12.4939 6.5546 12.75 6.5546C13.0061 6.5546 13.2564 6.47384 13.4689 6.32263C13.6815 6.17141 13.8467 5.95658 13.9435 5.70555C14.6084 3.98351 16.209 2.91435 18.1211 2.91435C19.3177 2.91435 20.4653 3.41765 21.3114 4.31353C22.1575 5.20942 22.6328 6.42449 22.6328 7.69146C22.6328 11.0377 19.8592 14.2623 17.5313 16.3767Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkheart);
export default __webpack_public_path__ + "static/media/pinkheart.7998bae969be86b5628f52be291b48f9.svg";
export { ForwardRef as ReactComponent };